import React, { useState } from 'react';
import { Typography, Container } from '@hpstellar/core';
import LazyLoad from 'react-lazyload';
import { withError } from '../../shared/components/error-boundary';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import SEOParagraph from './seo-paragraph';
import ShoppingLinks from './shopping-links';
import DisclaimerTabs from './disclaimer-tabs';
import AccessibleElement from '../../ui/components/accessible-element';
import useUserData from '../../hooks/useUserData';
import Chatbot from '../../home/components/chatbot';
import useChat from '../../hooks/useChat';

import '../css/disclaimer-v2.less';
import './disclaimer-v2.less';

const ChatSection = ({}) => {
    const { openChat } = useChat({
        analytics: {
            event: 'e_chat',
            chatAction: 'shirley_start_footer',
        },
    });
    const [showContact, setShowContact] = useState();
    const { userData } = useUserData();
    const { profileData, updatedFromService } = userData || {};
    const { isccf } = profileData || {};
    //wait till user data is available and make sure it's not call center
    if (!updatedFromService || isccf) {
        return null;
    }
    return (
        <section className="lp_chat">
            <LazyLoad height={91} once={true} offset={400}>
                <ImageWithPlaceholder
                    className="image-content"
                    src="//www.hp.com/us-en/shop/app/assets/images/uploads/prod/lpchat-square1606770930108674.png"
                    alt="Chat with a sales rep"
                />
            </LazyLoad>
            <h2>Need help?</h2>
            <a
                className="live_help_dd downDisclosure arrow-down"
                href=""
                onClick={e => {
                    e.preventDefault();
                    setShowContact(!showContact);
                }}
            >
                Contact us now
            </a>
            <ul className={'live_help_list' + (showContact ? ' show' : '')} onMouseLeave={() => setShowContact(false)}>
                <AccessibleElement element="li" onClick={openChat}>
                    <a className="lp_link">
                        <Typography variant="bodyM">Chat with a sales rep</Typography>
                    </a>
                </AccessibleElement>
                <li>
                    <a
                        href={`${process.env.BASENAME}/SendEmailView?catalogId=10051&langId=-1&storeId=10151`}
                        tabIndex={0}
                    >
                        <Typography variant="bodyM"> Send us an email</Typography>
                    </a>
                </li>
            </ul>
        </section>
    );
};

const getWordCloud = (wordCloud, brightEdgeLinks) => {
    const { links = [], tabName: title, categories = [] } = brightEdgeLinks || {};
    if ((!wordCloud || Array.isArray(wordCloud)) && links?.length > 0) {
        return {
            wcTabs: [{ title }],
            wcLinks: [{ links, categories }],
        };
    }
    return wordCloud;
};

class DisclaimerV2 extends React.PureComponent {
    static whyDidYouRender = true;

    constructor() {
        super();
        this.state = {
            showDisclaimer: false,
            showContact: false,
        };
    }

    handleToggleDisclaimer = () => {
        this.setState({ showDisclaimer: !this.state.showDisclaimer });
    };

    render() {
        const { wordCloud, isHomepage, useSeoV2, brightEdgeLinks } = this.props;
        return (
            <>
                <SEOParagraph className={'v2'} useSeoV2={useSeoV2} />
                <Container from="xs" className="shoppinglinks_support v2">
                    {isHomepage && (
                        <Chatbot lazyLoadSettings={{ skip: true, robots: true, offset: 800, mobileOffset: 500 }} />
                    )}
                    <ShoppingLinks />
                    {!isHomepage && <ChatSection />}
                </Container>
                <DisclaimerTabs wordCloud={getWordCloud(wordCloud, brightEdgeLinks)} />
            </>
        );
    }
}

export default withError(DisclaimerV2);
